module.exports = __webpack_public_path__ + "img/add_circle.d416dc6b.svg";